import CorporateActionList from './CorporateActionList';
import DividendAccrualList from './DividendAccrualList';
import CashTransactionList from './CashTransactionList';
import TransactionTaxList from './TransactionTaxList';
import { withTabItems } from '../common/RoutableTabContainer';
import TransferList from './TransferList';
import CashTxnDivAccHoldingMixed from './CashTxnDivAccHoldingMixed';
import SalesTaxList from './SalesTaxList';
import BrokerTransactionList from './BrokerTransactionList';
import VBDividendList from './VBDividendList';
import IBFlexQueryList from '../brokerIB/IBFlexQueryList';


export default withTabItems([
  {
    label: 'Corpact',
    url: 'corporate-actions',
    comp: CorporateActionList,
  },
  {
    label: '! Div.Accrual',
    url: 'dividend-accruals',
    comp: DividendAccrualList,
  },
  {
    label: 'Cash Txn',
    url: 'cash-transactions',
    comp: CashTransactionList,
  },
  {
    label: 'Transaction Tax',
    url: 'transaction-taxes',
    comp: TransactionTaxList,
  },
  {
    label: 'Sales Tax',
    url: 'sales-taxes',
    comp: SalesTaxList,
  },
  {
    label: 'Transfers',
    url: 'transfers',
    comp: TransferList,
  },
  {
    label: 'Transactions',
    url: 'transactions',
    comp: BrokerTransactionList,
  },
  {
    label: '! VB Dividends',
    url: 'vb-dividends',
    comp: VBDividendList,
    tooltip: 'Virtual Dividends For Dividend Re-investment',
  },
  {
    label: '! CT Proc View',
    url: 'ct-proc-view',
    tooltip: 'Integrated view of Cash Transactions & Dividend Accruals to process Dividends',
    comp: CashTxnDivAccHoldingMixed,
  },
  {
    label: '! Flex Queries',
    url: 'flex-queries',
    comp: IBFlexQueryList,
  },
], () => 'IB Activity \u2022 ');
